import axios from "axios";

export const googleApi = axios.create({
  baseURL: import.meta.env.VITE_GOOGLE_API,
  headers: {
    "Content-Type": "application/json",
    "X-Goog-Api-Key": import.meta.env.VITE_GOOGLE_KEY,
  },
});
